import { useNotificationStore } from "@/store/pinia/notifications";

export default {
  install(Vue) {
    // Create a getter that returns the notification store instance
    // Using $notifications to avoid conflict with Element UI's $notify
    Object.defineProperty(Vue.prototype, "$notifications", {
      get() {
        return useNotificationStore();
      },
      configurable: true,
    });
  },
};
